import { useContext } from 'react';
import { AuthContext } from 'shared/contexts/auth-context';

export const useAuth = () => useContext(AuthContext);
